import { Component, OnInit } from '@angular/core';
import { IxellAPIService, StatsFeatureType } from 'src/app/tools/api.service';
import { HeaderService } from '../../tools/header.service';

@Component({
  selector: 'laca_maj',
  templateUrl: './maj.component.html',
  styleUrls: ['./maj.component.scss']
})
export class MajComponent implements OnInit {

  private statsLogFeatureSub: any;
  private majSub: any;
  majDic:any
  keys: string[];
  columns = ["maj", "dl"];

  constructor(private apiService: IxellAPIService, private headerService: HeaderService ) { }

  ngOnInit() {
    this.headerService.changeTitle("support.supportAssistance");
    this.majSub = this.apiService.checkMAJBalance().subscribe(data => {
      this.majDic = data;
      this.keys = Object.keys(this.majDic);
    });
  }

  ngOnDestroy() {
    if (this.statsLogFeatureSub != null) this.statsLogFeatureSub.unsubscribe();
  }

  dl(res: number) {
    this.statsLogFeatureSub = this.apiService.statsLogFeature(StatsFeatureType.UpdateDownload).subscribe(() => {
      if (this.statsLogFeatureSub != null) this.statsLogFeatureSub.unsubscribe();
    });

    window.open(this.majDic[res], "_blank");
  }

}
